<template>
  <div>
    <b-container fluid id="container" style="overflow:hidden;">
      <b-row v-if='cart'>
        <b-col>
          <h4 class="text-center pt-4 pb-3">Your Shopping Cart</h4>

          <b-row>
            <b-list-group class="mt-1" style="width:100%;">
              <b-list-group-item v-for="item in cart.items" :key="item.variant_id" class="d-flex w-100 justify-content-between">
                <div><a :href="productLink(item)"><b-img :width="100" :src="item.featured_image.url"></b-img></a></div>
                <div class="text-right">
                  <span style="font-weight:bold;"><a :href="productLink(item)" style="color:black;">{{item.product_title}}</a></span>
                  <br>
                  <span style="width:100%;font-size:small;color:#888888;">
                    <span v-for="(property_value, property_name) in item.properties" :key="property_name">
                      {{property_name | capitalize}}: {{property_value}}
                      <br>
                    </span>
                    <span v-if="isCustom(item.handle)">
                      <span v-for="opt in item.options_with_values" :key="opt.name">
                        {{opt.name | capitalize}}: {{opt.value}}
                        <br>
                      </span>
                    </span>
                    <span v-else>
                      Size: 12x18"
                      <br>
                      Finish: Paper
                      <br>
                    </span>
                  </span>
                  <span class="mt-3">
                    {{item.price | toDollars}}
                  </span>
                  <div class="mt-2">
                    <b-button @click="removeQuantity(item.variant_id, item.quantity)" size="sm" variant="secondary" style="margin-right:5px;">-</b-button> {{item.quantity}} <b-button @click="addQuantity(item.variant_id, item.quantity)" size="sm" variant="secondary" style="margin-left:5px;">+</b-button>
                  </div>
                </div>
              </b-list-group-item>
            </b-list-group>
          </b-row>

          <b-row v-if="!hasDiscount">
            <div style="margin-bottom:0px;background:red;color:white;padding:5px;text-align:center;width:90%;margin-top:15px;margin-left:auto;margin-right:auto;">
              <strong>LIMITED TIME OFFER</strong><br>Get 15% off your entire order<br>when you order any two posters!
            </div>
          </b-row>

          <b-row class="mt-3 mr-2 text-right">
            <div v-if="hasDiscount" style="width:100%;font-size:large;">
            <span>Discount: -{{cart.total_discount | toDollars }}</span>
            <br>
            <span style="font-size:small;color:red;">15% off when you order two</span>
            <br>
            </div>
            <div style="width:100%;font-size:large;">
            Shipping: FREE
            <br>
            Total: {{cart.total_price | toDollars }}
            </div>
          </b-row>

          <b-row class="mt-3">
            <b-button @click="checkoutLink" size="lg" variant="warning" style="width:90%;margin-left:auto;margin-right:auto;">CHECKOUT
              <span style="float:right;margin-right:15px;"> 
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" style="margin-top:8px;margin-left:3px;position:absolute;">
                  <path transform="scale(0.05)" d="M94.35 0l-35.7 35.7L175.95 153 58.65 270.3l35.7 35.7 153-153z"/>
                </svg>
              </span>
            </b-button>
          </b-row>
          <b-row class="mt-4 pb-3">
            <div><b-img fluid src="https://cdn.shopify.com/s/files/1/0067/9378/9499/files/trust-mobile_541x.webp"></b-img></div>
          </b-row>
        </b-col>
      </b-row>

      <b-row v-if="!cart && !ui.loading">
        <b-col>
          <h4 class="text-center mt-3 pb-3">Your Shopping Cart</h4>

          <b-row class="mt-5">
            <div class="text-center" style="margin-left:auto;margin-right:auto;font-size:large;">
              <strong>There are no items in your cart.</strong>
            </div>
          </b-row>

          <b-row class="mt-5">
            <b-button href="https://instantlyart.com/map-designer?ref=cart" size="lg" variant="primary" style="margin-left:auto;margin-right:auto;width:90%;">Design a City Map</b-button>
          </b-row>
          <b-row class="mt-3 pb-3">
            <b-button href="https://instantlyart.com/waveform-designer?ref=cart" size="lg" variant="primary" style="margin-left:auto;margin-right:auto;width:90%;">Design a Soundwave</b-button>
          </b-row>
        </b-col>
      </b-row>

      <b-row v-if="!cart && ui.loading">
        <b-col>
          <h4 class="text-center mt-3 pb-3">Your Shopping Cart</h4>

          <b-row class="mt-5">
            <div class="text-center" style="margin-left:auto;margin-right:auto;font-size:large;">
              <strong>Grabbing cart...</strong>
            </div>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
const axios = require('axios')
export default {
  name: 'cart',
  data() {
    return {
      ui: {
        loading: false
      },
      open: true,
      cart: null
    }
  },
  filters: {
    toDollars: function (val) {
      return '$' + (val / 100).toFixed(2)
    },
    capitalize: function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    }
  },
  computed: {
    hasDiscount: function () {
      return this.cart.total_discount > 0
    }
  },
  methods: {
    isCustom: function (str) {
      return str.indexOf('custom') >= 0
    },
    productLink: function (item) {
      if (item.handle === "custom-city-map-art-print") {
        return `https://instantlyart.com/map-designer?ref=cart&d=0&style=${item.properties.style}`
      } else if (item.handle === "custom-waveform-print") {
        return `https://instantlyart.com/waveform-designer?ref=cart&d=0&style=${item.properties.style}`
      } else {
        return `https://instantlyart.com/products/${item.handle}?ref=cart`
      }
    },
    addQuantity: function (variant, quantity) {
      var self = this
      var itemIndex = this.cart.items.findIndex(i => i.variant_id === variant)
      // this.cart.items[itemIndex].quantity++

      var update = {}
      update[this.cart.items[itemIndex].key] = this.cart.items[itemIndex].quantity + 1

      self.ui.loading = true
      // self.cart = null

      axios.post('/cart/update.js', {
        updates: update
      })
      .then((response) => {
        console.log(response)
        self.ui.loading = false
        self.cart = response.data
      })
      .catch((err) => {
        self.ui.loading = false
        console.log(err)
      })
    },
    removeQuantity: function (variant, quantity) {
      var self = this
      var itemIndex = this.cart.items.findIndex(i => i.variant_id === variant)
      // this.cart.items[itemIndex].quantity--

      var update = {}
      update[this.cart.items[itemIndex].key] = this.cart.items[itemIndex].quantity - 1

      self.ui.loading = true
      // self.cart = null

      axios.post('/cart/update.js', {
        updates: update
      })
      .then((response) => {
        console.log(response)
        self.ui.loading = false
        
        try {
          if (response.data.items.length > 0) {
            self.cart = response.data
          } else {
            self.cart = null
          }
        } catch (e) {
          console.error(e)
          self.cart = null
        }
      })
      .catch((err) => {
        self.ui.loading = false
        console.log(err)
      })
    },
    getCart: function () {
      var self = this
      self.ui.loading = true
      axios.get('/cart.js')
      .then((response) => {
        console.log(response)

        try {
          if (response.data.items.length > 0) {
            self.cart = response.data
          } else {
            self.cart = null
          }
        } catch (e) {
          console.error(e)
          self.cart = null
        }

        self.ui.loading = false
      })
      .catch((err) => {
        console.log(err)
        self.ui.loading = false
      })
    },
    checkoutLink: function () {
      window.location.href = 'https://instantlyart.com/checkout'
    }
  },
  created () {
    this.getCart()
  },
  async mounted() {

  }
}
</script>
<style scoped>
.btn {
  box-shadow:0px 3px 1px -2px rgba(0, 0, 0, .2), 0px 2px 2px 0px rgba(0, 0, 0, .14), 0px 1px 5px 0px rgba(0, 0, 0, .12);
  border-radius:0px!important;
}
</style>


// WEBPACK FOOTER //
// src/components/Cart.vue